
// @ts-nocheck
import locale__app_apps_concierge_src_lang_en_US_json from "../src/lang/en-US.json";
import locale__app_apps_concierge_src_lang_fr_FR_json from "../src/lang/fr-FR.json";
import locale__app_apps_concierge_src_lang_es_ES_json from "../src/lang/es-ES.json";


export const localeCodes =  [
  "en",
  "fr",
  "es"
]

export const localeLoaders = {
  "en": [{ key: "../src/lang/en-US.json", load: () => Promise.resolve(locale__app_apps_concierge_src_lang_en_US_json), cache: true }],
  "fr": [{ key: "../src/lang/fr-FR.json", load: () => Promise.resolve(locale__app_apps_concierge_src_lang_fr_FR_json), cache: true }],
  "es": [{ key: "../src/lang/es-ES.json", load: () => Promise.resolve(locale__app_apps_concierge_src_lang_es_ES_json), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "language": "en-US",
      "files": [
        "/app/apps/concierge/src/lang/en-US.json"
      ]
    },
    {
      "code": "fr",
      "language": "fr-FR",
      "files": [
        "/app/apps/concierge/src/lang/fr-FR.json"
      ]
    },
    {
      "code": "es",
      "language": "es-ES",
      "files": [
        "/app/apps/concierge/src/lang/es-ES.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": "lang",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "language": "en-US",
    "files": [
      {
        "path": "/app/apps/concierge/src/lang/en-US.json"
      }
    ]
  },
  {
    "code": "fr",
    "language": "fr-FR",
    "files": [
      {
        "path": "/app/apps/concierge/src/lang/fr-FR.json"
      }
    ]
  },
  {
    "code": "es",
    "language": "es-ES",
    "files": [
      {
        "path": "/app/apps/concierge/src/lang/es-ES.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
